import { memo } from 'react';
import dayjs from 'dayjs';
import Image from 'next/image';
import imageUrlBuilder from '@sanity/image-url';
import client from '@sanity/sanity.config';
import getReadTimeLabel from '@utils/getReadTimeLabel';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import classnames from 'classnames';
import { IAuthorDetailsProps } from './AuthorDetails.types';
import styles from './styles.module.scss';

export const AuthorDetails = memo<IAuthorDetailsProps>(
  ({ className, name, image, linkedin, readTime, publishedAt }) => (
    <Link
      href={linkedin || ''}
      className={classnames(styles.container, className)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image
        alt="author"
        width={0}
        height={0}
        sizes="50vw"
        src={
          image
            ? imageUrlBuilder(client)
                .image(image || '')
                .fit('max')
                .auto('format')
                .url() || ''
            : ''
        }
      />
      <div className={styles.details}>
        <span className={styles.name}>{name}</span>
        <span className={styles.publishedAt}>
          {`${dayjs(publishedAt).format('MMM D, YYYY')} · ${getReadTimeLabel(readTime)}`}
        </span>
      </div>
    </Link>
  ),
);

AuthorDetails.displayName = 'AuthorDetails';

export default dynamic(() => Promise.resolve(AuthorDetails), { ssr: false });
